import classNames from "classnames";
import helpers from "utils/helpers";

export default function GeneralSubmissionInfo({
  submission,
  markAsGradedHandler,
}) {
  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-xl font-bold">Submission Information</h2>
      <div className="flex flex-col gap-2 *:py-3 border rounded-md p-2 shadow-lg">
        <div className="flex-1 flex  gap-2 border-b">
          <div className="flex flex-col flex-1 gap-2">
            <p className="font-bold">Submission ID: </p>
            <p>{submission?._id}</p>
          </div>
          <div className="flex flex-col flex-1 gap-2">
            <p className="font-bold">Submitted At: </p>
            <p>{helpers.dateFormat(submission?.createdAt)}</p>
          </div>
        </div>

        <div className="flex  gap-2 border-b">
          <div className="flex flex-col flex-1 gap-2">
            <p className="font-bold">Is Passed :</p>
            {submission?.isPassed ? (
              <p className="text-green-500">Passed</p>
            ) : (
              <p className="text-red-500">Failed</p>
            )}
          </div>
          <div className="flex flex-col flex-1 gap-2">
            <p className="font-bold">Attempt Number:</p>
            <p>{submission?.attemptNumber}</p>
          </div>
        </div>
        <div className="flex gap-4 border-b">
          <div className="flex-1">
            <p className="font-bold">Grading At:</p>
            {submission?.gradedAt ? (
              <p className="text-green-500">
                Graded {helpers.dateFormat(submission?.gradedAt)}
              </p>
            ) : (
              <p className="text-red-500">Not Graded</p>
            )}
          </div>
          <div className="flex-1">
            <p className="font-bold">Status:</p>
            {submission?.status === "pending" ? (
              <p className="text-yellow-500">Pending </p>
            ) : (
              <p className="text-green-500">Graded</p>
            )}
          </div>
        </div>
        <div className="flex flex-row gap-2 ">
          <div className="flex-1 flex-col  gap-2">
            <p className="font-bold">Total Score:</p>
            <p>{submission?.totalScore}</p>
          </div>
          <div className="flex-1 flex-col  gap-2">
            <p className="font-bold">Max Score:</p>
            <p>{submission?.maxScore}</p>
          </div>
        </div>
        <div className="flex flex-col gap-2 ">
          <p className="font-bold">Percentage:</p>
          <p className="text-2xl font-bold">
            {((submission?.totalScore / submission?.maxScore) * 100).toFixed(2)}
            %
          </p>
        </div>
        <div className="flex flex-row gap-2  mt-8 border-t">
          <div className="flex-1 flex-col  gap-2">
            <p className="font-bold">Agent Name:</p>
            <p>
              {submission?.userId?.firstName +
                " " +
                submission?.userId?.lastName}
            </p>
          </div>
          <div className="flex-1 flex-col  gap-2">
            <p className="font-bold">Agent Email:</p>
            <p>{submission?.userId?.email}</p>
          </div>
        </div>

        <button
          className={classNames(
            submission?.gradedAt
              ? "bg-yellow-500 text-white px-4 py-2 rounded-md"
              : "bg-green-500 text-white px-4 py-2 rounded-md"
          )}
          onClick={() => {
            markAsGradedHandler &&
              markAsGradedHandler(
                submission?._id,
                submission?.gradedAt ? true : false
              );
          }}
        >
          {submission?.gradedAt ? "Mark as Pending" : "Mark as Graded"}
        </button>
      </div>
    </section>
  );
}
